(function () {
    const list = document.querySelector('[data-home-article-list]');
    if (!list) return;

    const rows = Array.from(list.querySelectorAll(':scope > [data-published-year]'));
    if (!rows.length) return;

    const groupedList = document.createDocumentFragment();
    let currentYear;
    let currentSection;

    rows.forEach(function (row) {
        const year = row.dataset.publishedYear;

        if (year !== currentYear) {
            currentYear = year;
            currentSection = document.createElement('section');
            currentSection.className = 'home-year-section';
            currentSection.innerHTML = `
                <h2 class="home-year-heading">${year}</h2>
                <div class="home-year-articles"></div>
            `;
            groupedList.appendChild(currentSection);
        }

        currentSection.querySelector('.home-year-articles').appendChild(row);
    });

    list.replaceChildren(groupedList);
    list.classList.add('is-grouped');
})();
